import React from 'react';

import ReactPagination from 'react-js-pagination';

import classes from './styles.module.scss';

export default function Pagination({
  activePage,
  itemsCountPerPage,
  totalItemsCount,
  pageRangeDisplayed,
  onChange,
}) {
  return (
    <div className={classes.Pagination}>
      <ReactPagination
        itemClass={classes.button}
        innerClass={classes.buttonsList}
        activeClass={classes.active}
        disabledClass={classes.disabled}
        activePage={activePage}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pageRangeDisplayed}
        prevPageText="Prev"
        nextPageText="Next"
        onChange={onChange}
      />
    </div>
  );
}
